import { createExternalRouteRef } from '@mainstage/core-plugin-api';

export const marketplaceProductExternalRouteRef = createExternalRouteRef({
  id: 'marketplace-product-external-ref',
  params: ['id'],
});
